import React from 'react'
import { Row, Table, Col } from 'antd'
import {
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  AreaChart,
  Area,
} from 'recharts'
import _isEmpty from 'lodash/isEmpty'
import './ILTSShift.css'
// import Chart from 'modules/Dashboard/Components/NLVIndividualReport/Chart'

export default function IltsShiftTable({
  reportData,
  columns,
  loading,
  newLevelData,
}) {
  const data = reportData.map((report, key) => {
    return { key, ...report }
  })
  let pnChartData = []
  let pnChartDataWithInterest = []
  let pnOverCharData = []
  let nlvCharData = []
  let overAllPlChartData = []
  let nlvWithIntrestChartData = []

  const getDataByParticulars = (searchTerm) => {
    return reportData.find(
      (item) => item.particulars && item.particulars.includes(searchTerm)
    )
  }

  if (reportData.length !== 0) {
    const spotPriceData = getDataByParticulars('Spot Price')
    const changePnLData = getDataByParticulars('Change in P&L without interest')
    const changePnLWithInterestData = getDataByParticulars(
      'Change in P&L with interest'
    )
    //const overallPnLData = getDataByParticulars('Overall P&L without interest')
    const overallPnLWithInterestData = getDataByParticulars(
      'Overall P&L with interest'
    )
    const nlvData = getDataByParticulars('NLV without interest')
    const nlvWithInterestData = getDataByParticulars('NLV with interest')

    if (changePnLData) {
      Object.keys(changePnLData).forEach((key) => {
        if (key !== 'particulars') {
          let newObj = {}
          newObj['Current Position'] = changePnLData[key]
          newObj['name'] = changePnLData[key]
          newObj['spotPrice'] = spotPriceData?.[key]
          pnChartData.push(newObj)
        }
      })
    }

    if (pnChartDataWithInterest) {
      Object.keys(changePnLWithInterestData).forEach((key) => {
        if (key !== 'particulars') {
          let newObj = {}
          newObj['Current Position'] = changePnLWithInterestData[key]
          newObj['name'] = changePnLWithInterestData[key]
          newObj['spotPrice'] = spotPriceData?.[key]
          pnChartDataWithInterest.push(newObj)
        }
      })
    }

    if (overallPnLWithInterestData) {
      Object.keys(overallPnLWithInterestData).forEach((key) => {
        if (key !== 'particulars') {
          let newObj = {}
          newObj['Current Position'] = overallPnLWithInterestData[key]
          newObj['name'] = overallPnLWithInterestData[key]
          newObj['spotPrice'] = spotPriceData?.[key]
          pnOverCharData.push(newObj)
        }
      })
    }

    if (nlvData) {
      Object.keys(nlvData).forEach((key) => {
        if (key !== 'particulars') {
          let newObj = {}
          newObj['Current Position'] = nlvData[key]
          newObj['name'] = nlvData[key]
          newObj['spotPrice'] = spotPriceData?.[key]
          nlvCharData.push(newObj)
        }
      })
    }

    if (overallPnLWithInterestData) {
      Object.keys(overallPnLWithInterestData).forEach((key) => {
        if (key !== 'particulars') {
          let newObj = {}
          newObj['Current Position'] = overallPnLWithInterestData[key]
          newObj['name'] = overallPnLWithInterestData[key]
          newObj['spotPrice'] = spotPriceData?.[key]
          overAllPlChartData.push(newObj)
        }
      })
    }

    if (nlvWithInterestData) {
      Object.keys(nlvWithInterestData).forEach((key) => {
        if (key !== 'particulars') {
          let newObj = {}
          newObj['Current Position'] = nlvWithInterestData[key]
          newObj['name'] = nlvWithInterestData[key]
          newObj['spotPrice'] = spotPriceData?.[key]
          nlvWithIntrestChartData.push(newObj)
        }
      })
    }
  }
  const formatYAxis = (value) => {
    const absValue = Math.abs(value)
    let formattedValue = ''

    if (absValue < 1000) {
      formattedValue = absValue.toString()
    } else if (absValue >= 10000000) {
      formattedValue = `${(absValue / 10000000).toFixed(0)} CR`
    } else if (absValue >= 100000) {
      formattedValue = `${(absValue / 100000).toFixed(0)} L`
    } else if (absValue >= 1000) {
      formattedValue = `${(absValue / 1000).toFixed(0)} K`
    }

    return value < 0 ? `- ${formattedValue}` : formattedValue
  }

  const getRange = (data) => {
    const openPosition = data?.map((item) => item['Current Position'])
    const shifted = data
      ?.map((item) => {
        const keys = Object.keys(item)
        const shiftedKey = keys.find((key) => key.startsWith('Shifted to'))
        return shiftedKey ? item[shiftedKey] : null
      })
      .filter((item) => item !== null)

    const mainArray = [...openPosition, ...shifted]

    if (mainArray.length === 0) return [0, 0]

    const minValue = Math.min(...mainArray)
    const maxValue = Math.max(...mainArray)
    const base = Math.max(Math.abs(minValue), Math.abs(maxValue))

    let padding = base * 0.05

    if (base > 10000000) {
      padding = Math.max(Math.ceil(padding / 100000) * 100000, 100000)
    } else if (base > 100000) {
      padding = Math.max(Math.ceil(padding / 10000) * 10000, 10000)
    } else if (base > 1000) {
      padding = Math.max(Math.ceil(padding / 1000) * 1000, 1000)
    } else {
      padding = Math.max(Math.ceil(padding), 1)
    }

    return [minValue - padding, maxValue + padding]
  }
  return (
    <>
      <div className='analysis_graph'>
        <Table
          loading={loading}
          dataSource={data}
          columns={columns}
          className='nlv-tracker-report'
          pagination={{ pageSize: 100, hideOnSinglePage: true }}
          // scroll={{ x: true, y: 'calc(100vh - 72px - 24px - 24px - 36px - 35px)' }}
        />
      </div>
      <Row className='analysis_graph_row' gutter={16}>
        {!_isEmpty(pnChartData) && (
          <Col
            sm={24}
            md={12}
            lg={8}
            className='analysis_graph_col'
            style={{
              marginBottom: '10px',
            }}
          >
            <div className='scenario_analysis_graph'>
              <div className='scenario_analysis_graph_Heading'>
                Change in P&L
              </div>
              <ResponsiveContainer width='100%' height={270}>
                <AreaChart
                  width={350}
                  height={270}
                  data={pnChartData}
                  margin={{ top: 10, right: 10, bottom: 30, left: 10 }}
                >
                  <XAxis
                    dataKey='spotPrice'
                    label={{
                      value: `Spot Price`,
                      style: { textAnchor: 'middle' },
                      // angle: -20,
                      position: 'bottom',
                      offset: -1,
                    }}
                    padding={{ top: 20, bottom: 20, left: 5 }}
                    margin={{ bottom: 10 }}
                  />
                  <YAxis
                    label={{
                      value: 'P&L',
                      angle: -90,
                      position: 'insideLeft',
                      style: { textAnchor: 'middle' },
                    }}
                    dataKey='name'
                    tickFormatter={formatYAxis}
                    padding={{ top: 20, bottom: 20 }}
                    domain={getRange(pnChartData)}
                  />
                  <CartesianGrid strokeDasharray='3 3' />
                  <Tooltip />
                  <Area
                    type='monotone'
                    dataKey='Current Position'
                    stroke='#50CD89'
                    fill='#50CD89'
                    dot={{ stroke: '#50CD89', strokeWidth: 4 }}
                  />
                  {/* <Legend
                    margin={{ right: 10, top: 15 }}
                    wrapperStyle={{
                      padding: '15px 6px 6px 54px',
                    }}
                    // itemStyle={{ padding: '10px' }}
                  /> */}
                </AreaChart>
              </ResponsiveContainer>
            </div>
          </Col>
        )}

        {!_isEmpty(pnOverCharData) && (
          <Col
            sm={24}
            md={12}
            lg={8}
            className='analysis_graph_col'
            style={{
              marginBottom: '10px',
            }}
          >
            <div className='scenario_analysis_graph'>
              <div className='scenario_analysis_graph_Heading'>Overall P&L</div>
              <ResponsiveContainer width='100%' height={270}>
                <AreaChart
                  width={350}
                  height={270}
                  data={pnOverCharData}
                  margin={{ top: 10, right: 10, bottom: 30, left: 10 }}
                >
                  <XAxis
                    label={{
                      value: `Spot Price`,
                      style: { textAnchor: 'middle' },
                      // angle: -20,
                      position: 'bottom',
                      offset: -1,
                    }}
                    padding={{ top: 20, bottom: 20, left: 5 }}
                    margin={{ bottom: 10 }}
                    dataKey='spotPrice'
                  />
                  <YAxis
                    label={{
                      value: 'P&L',
                      angle: -90,
                      position: 'insideLeft',
                      style: { textAnchor: 'middle' },
                    }}
                    domain={getRange(pnOverCharData)}
                    tickFormatter={formatYAxis}
                    padding={{ top: 20, bottom: 20, left: 5 }}
                  />
                  <CartesianGrid strokeDasharray='3 3' />
                  <Tooltip />
                  <Area
                    type='monotone'
                    dataKey='Current Position'
                    stroke='#50CD89'
                    fill='#50CD89'
                    dot={{ stroke: '#50CD89', strokeWidth: 4 }}
                  />
                  {/* <Legend
                    margin={{ right: 10, top: 15 }}
                    wrapperStyle={{
                      padding: '15px 6px 6px 54px',
                    }}
                    // itemStyle={{ padding: '10px' }}
                  /> */}
                </AreaChart>
              </ResponsiveContainer>
            </div>
          </Col>
        )}

        {!_isEmpty(nlvCharData) && (
          <Col
            sm={24}
            md={12}
            lg={8}
            className='analysis_graph_col'
            style={{
              marginBottom: '10px',
            }}
          >
            <div className='scenario_analysis_graph'>
              <div className='scenario_analysis_graph_Heading'>
                NLV at Current Position
              </div>
              <ResponsiveContainer width='100%' height={270}>
                <AreaChart
                  width={350}
                  height={270}
                  data={nlvCharData}
                  margin={{ top: 10, right: 10, bottom: 30, left: 10 }}
                >
                  <XAxis
                    label={{
                      value: `Spot Price`,
                      style: { textAnchor: 'middle' },
                      // angle: -20,
                      position: 'bottom',
                      offset: -1,
                    }}
                    padding={{ top: 20, bottom: 20, left: 5 }}
                    margin={{ bottom: 10 }}
                    dataKey='spotPrice'
                  />
                  <YAxis
                    label={{
                      value: 'NLV',
                      angle: -90,
                      position: 'insideLeft',
                      style: { textAnchor: 'middle' },
                    }}
                    tickFormatter={formatYAxis}
                    padding={{ top: 20, bottom: 20, left: 5 }}
                    domain={getRange(nlvCharData)}
                  />
                  <CartesianGrid strokeDasharray='3 3' />
                  <Tooltip />
                  <Area
                    type='monotone'
                    dataKey='Current Position'
                    stroke='#50CD89'
                    fill='#50CD89'
                    dot={{ stroke: '#50CD89', strokeWidth: 4 }}
                  />
                  {/* <Legend
                    margin={{ right: 10, top: 15 }}
                    wrapperStyle={{
                      padding: '15px 6px 6px 54px',
                    }}
                    // itemStyle={{ padding: '10px' }}
                  /> */}
                </AreaChart>
              </ResponsiveContainer>
            </div>
          </Col>
        )}

        {!_isEmpty(overAllPlChartData) && (
          <Col
            sm={24}
            md={12}
            lg={8}
            className='analysis_graph_col'
            style={{
              marginBottom: '10px',
            }}
          >
            <div className='scenario_analysis_graph'>
              <div className='scenario_analysis_graph_Heading'>
                Overall P&L With Interest
              </div>
              <ResponsiveContainer width='100%' height={270}>
                <AreaChart
                  width={350}
                  height={270}
                  data={overAllPlChartData}
                  margin={{ top: 10, right: 10, bottom: 30, left: 10 }}
                >
                  <XAxis
                    label={{
                      value: `Spot Price`,
                      style: { textAnchor: 'middle' },
                      // angle: -20,
                      position: 'bottom',
                      offset: -1,
                    }}
                    padding={{ top: 20, bottom: 20, left: 5 }}
                    margin={{ bottom: 10 }}
                    dataKey='spotPrice'
                  />
                  <YAxis
                    label={{
                      value: 'P&L',
                      angle: -90,
                      position: 'insideLeft',
                      style: { textAnchor: 'middle' },
                    }}
                    tickFormatter={formatYAxis}
                    padding={{ top: 20, bottom: 20, left: 5 }}
                    domain={getRange(overAllPlChartData)}
                  />
                  <CartesianGrid strokeDasharray='3 3' />
                  <Tooltip />
                  <Area
                    type='monotone'
                    dataKey='Current Position'
                    stroke='#50CD89'
                    fill='#50CD89'
                    dot={{ stroke: '#50CD89', strokeWidth: 4 }}
                  />
                  {/* <Legend
                    margin={{ right: 10, top: 15 }}
                    wrapperStyle={{
                      padding: '15px 6px 6px 54px',
                    }}
                    // itemStyle={{ padding: '10px' }}
                  /> */}
                </AreaChart>
              </ResponsiveContainer>
            </div>
          </Col>
        )}

        {!_isEmpty(nlvWithIntrestChartData) && (
          <Col
            sm={24}
            md={12}
            lg={8}
            className='analysis_graph_col'
            style={{
              marginBottom: '10px',
            }}
          >
            <div className='scenario_analysis_graph'>
              <div className='scenario_analysis_graph_Heading'>
                NLV With Interest
              </div>
              <ResponsiveContainer width='100%' height={270}>
                <AreaChart
                  width={350}
                  height={270}
                  data={nlvWithIntrestChartData}
                  margin={{ top: 10, right: 10, bottom: 30, left: 10 }}
                >
                  <XAxis
                    label={{
                      value: `Spot Price`,
                      style: { textAnchor: 'middle' },
                      // angle: -20,
                      position: 'bottom',
                      offset: -1,
                    }}
                    padding={{ top: 20, bottom: 20, left: 5 }}
                    margin={{ bottom: 10 }}
                    dataKey='spotPrice'
                  />
                  <YAxis
                    label={{
                      value: 'NLV',
                      angle: -90,
                      position: 'insideLeft',
                      style: { textAnchor: 'middle' },
                    }}
                    tickFormatter={formatYAxis}
                    padding={{ top: 20, bottom: 20 }}
                    domain={getRange(nlvWithIntrestChartData)}
                  />
                  <CartesianGrid strokeDasharray='3 3' />
                  <Tooltip />
                  <Area
                    type='monotone'
                    dataKey='Current Position'
                    stroke='#50CD89'
                    fill='#50CD89'
                    dot={{ stroke: '#50CD89', strokeWidth: 4 }}
                  />
                  {/* <Legend
                    margin={{ right: 10, top: 15 }}
                    wrapperStyle={{
                      padding: '15px 6px 6px 54px',
                    }}
                    // itemStyle={{ padding: '10px' }}
                  /> */}
                </AreaChart>
              </ResponsiveContainer>
            </div>
          </Col>
        )}
        {!_isEmpty(pnChartDataWithInterest) && (
          <Col
            sm={24}
            md={12}
            lg={8}
            className='analysis_graph_col'
            style={{
              marginBottom: '10px',
            }}
          >
            <div className='scenario_analysis_graph'>
              <div className='scenario_analysis_graph_Heading'>
                Change in P&L with Interest
              </div>
              <ResponsiveContainer width='100%' height={270}>
                <AreaChart
                  width={350}
                  height={270}
                  data={pnChartDataWithInterest}
                  margin={{ top: 10, right: 10, bottom: 30, left: 10 }}
                >
                  <XAxis
                    dataKey='spotPrice'
                    label={{
                      value: `Spot Price`,
                      style: { textAnchor: 'middle' },
                      position: 'bottom',
                      offset: -1,
                    }}
                    padding={{ top: 20, bottom: 20, left: 5 }}
                    margin={{ bottom: 10 }}
                  />
                  <YAxis
                    label={{
                      value: 'P&L',
                      angle: -90,
                      position: 'insideLeft',
                      style: { textAnchor: 'middle' },
                    }}
                    dataKey='name'
                    tickFormatter={formatYAxis}
                    padding={{ top: 20, bottom: 20 }}
                    domain={getRange(pnChartData)}
                  />
                  <CartesianGrid strokeDasharray='3 3' />
                  <Tooltip />
                  <Area
                    type='monotone'
                    dataKey='Current Position'
                    stroke='#50CD89'
                    fill='#50CD89'
                    dot={{ stroke: '#50CD89', strokeWidth: 4 }}
                  />
                </AreaChart>
              </ResponsiveContainer>
            </div>
          </Col>
        )}
      </Row>
    </>
  )
}
